(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-selector-components/assets/javascripts/draw-panel.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-selector-components/assets/javascripts/draw-panel.js');

'use strict';

const DrawPanel = _ref => {
  let {
    isSecondary,
    children,
    className
  } = _ref;
  const classNames = ['draw-panel'];
  if (className) {
    classNames.push(className);
  }
  if (isSecondary) {
    classNames.push('draw-panel-secondary');
  } else {
    classNames.push('draw-panel-primary');
  }
  return React.createElement("div", {
    className: classNames.join(' ')
  }, children);
};
setGlobal('svs.components.tipsen.drawSelectorComponents', {
  DrawPanel
});

 })(window);